import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-switch-lang';

class ViberSettings extends Component {
  render() {
    return (
      <section>
        Viber
      </section>
    );
  }
}

ViberSettings.propTypes = {};

export default translate(ViberSettings);
